const customCSSPropertiesMap: Record<string, string> = {
  activeDrawerWidth: '--awsui-active-drawer-width-rrnppm',
  offsetTop: '--awsui-offset-top-rrnppm',
  offsetTopWithNotifications: '--awsui-offset-top-with-notifications-rrnppm',
  contentGapLeft: '--awsui-content-gap-left-rrnppm',
  contentGapRight: '--awsui-content-gap-right-rrnppm',
  contentHeight: '--awsui-content-height-rrnppm',
  defaultMaxContentWidth: '--awsui-default-max-content-width-rrnppm',
  defaultMinContentWidth: '--awsui-default-min-content-width-rrnppm',
  footerHeight: '--awsui-footer-height-rrnppm',
  headerHeight: '--awsui-header-height-rrnppm',
  layoutWidth: '--awsui-layout-width-rrnppm',
  mainOffsetLeft: '--awsui-main-offset-left-rrnppm',
  maxContentWidth: '--awsui-max-content-width-rrnppm',
  minContentWidth: '--awsui-min-content-width-rrnppm',
  mobileBarHeight: '--awsui-mobile-bar-height-rrnppm',
  notificationsHeight: '--awsui-notifications-height-rrnppm',
  overlapHeight: '--awsui-overlap-height-rrnppm',
  navigationWidth: '--awsui-navigation-width-rrnppm',
  splitPanelReportedHeaderSize: '--awsui-split-panel-reported-header-size-rrnppm',
  splitPanelReportedSize: '--awsui-split-panel-reported-size-rrnppm',
  splitPanelHeight: '--awsui-split-panel-height-rrnppm',
  splitPanelMinWidth: '--awsui-split-panel-min-width-rrnppm',
  splitPanelMaxWidth: '--awsui-split-panel-max-width-rrnppm',
  toolsMaxWidth: '--awsui-tools-max-width-rrnppm',
  toolsWidth: '--awsui-tools-width-rrnppm',
  toolsAnimationStartingOpacity: '--awsui-tools-animation-starting-opacity-rrnppm',
  contentScrollMargin: '--awsui-content-scroll-margin-rrnppm',
  flashbarStackDepth: '--awsui-flashbar-stack-depth-rrnppm',
  flashbarStackIndex: '--awsui-flashbar-stack-index-rrnppm',
  flashbarStickyBottomMargin: '--awsui-flashbar-sticky-bottom-margin-rrnppm',
  stackedNotificationsBottomMargin: '--awsui-stacked-notifications-bottom-margin-rrnppm',
  stackedNotificationsDefaultBottomMargin: '--awsui-stacked-notifications-default-bottom-margin-rrnppm',
};
export default customCSSPropertiesMap;
